import { humanReadableField } from '~/filters/humanReadableField';
import { packagingId } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';

export class NLUO extends LegrandModule {
    get fieldPackaging() {
        if (this.packaging) {
            return packagingId(humanReadableField(this.packaging));
        }
    }
}
